/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_field_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const es_pct_field_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantidad`)
};

const de_pct_field_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betrag`)
};

const nl_pct_field_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedrag`)
};

const fr_pct_field_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montant`)
};

const it_pct_field_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importo`)
};

const pt_br2_pct_field_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

const pt_pct_field_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montante`)
};

const ja_pct_field_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金額`)
};

const zh_pct_field_amount = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金额`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_field_amount = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_field_amount(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_field_amount", locale)
	if (locale === "en") return en_pct_field_amount(inputs)
	if (locale === "es") return es_pct_field_amount(inputs)
	if (locale === "de") return de_pct_field_amount(inputs)
	if (locale === "nl") return nl_pct_field_amount(inputs)
	if (locale === "fr") return fr_pct_field_amount(inputs)
	if (locale === "it") return it_pct_field_amount(inputs)
	if (locale === "pt-BR") return pt_br2_pct_field_amount(inputs)
	if (locale === "pt") return pt_pct_field_amount(inputs)
	if (locale === "ja") return ja_pct_field_amount(inputs)
	return zh_pct_field_amount(inputs)
};